import React, { useState } from "react";

import Link from "next/link";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import Linkify from "react-linkify";

import { StorefrontData } from "data/storefront";
import { Button, Icon, IconVariant, LargeInput } from "studio-design-system";

import { ImageWithBlur } from "~/components/common/ImageWithBlur/ImageWithBlur";

import { emailValidRegex } from "../../../../util/validateEmail";
import * as baseStyles from "../FormLayout.css";

interface Props {
  storefrontData: StorefrontData;
}
export const DescModal = ({ storefrontData }: Props): React.ReactElement => {
  return (
    <div className={baseStyles.container}>
      <div className={baseStyles.topSection}>
        <div className={baseStyles.titleRow}>
          <div className={baseStyles.titleImg}>
            <ImageWithBlur
              src={storefrontData.welcomePosterImageURL}
              width={32}
              height={32}
              layout={"fixed"}
              objectFit={"cover"}
              alt={storefrontData.title}
            />
          </div>
          <h3 className={baseStyles.descModalTitle}>{storefrontData.creatorName}</h3>
          <Icon
            className={baseStyles.verifiedIcon}
            variant={IconVariant.CircleCheck}
            width={14}
            height={14}
          />
        </div>
        <div className={baseStyles.descModalText}>{storefrontData.description}</div>
      </div>
    </div>
  );
};
